// removed by extract-text-webpack-plugin
module.exports = {"splitsDividends":"finance_historical-data-panel_splitsDividends","sdCont":"finance_historical-data-panel_sdCont","wide":"finance_historical-data-panel_wide","filter":"finance_historical-data-panel_filter","item":"finance_historical-data-panel_item","label":"finance_historical-data-panel_label","selectButton":"finance_historical-data-panel_selectButton","icon":"finance_historical-data-panel_icon","intervalSelector":"finance_historical-data-panel_intervalSelector"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/finance-components/src/components/historical-data-panel/style.less
// module id = 728
// module chunks = 0